import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LdsEventBusService } from '../../services/lds-event-bus.service';
import { IconsService } from '../../services/icons.service';
import { LdsUserService } from '../../services/lds-user.service';

@Component({
    selector: 'lds-featureset-card',
    templateUrl: './featureset-card.component.html',
    styleUrls: ['./featureset-card.component.css'],
    standalone: false
})
export class FeaturesetCardComponent implements OnInit {
    @Input() featureSet: any;
    margin: string;
    constructor(public icons: IconsService, private eventBus: LdsEventBusService, private router: Router, private user: LdsUserService) {

    }

    ngOnInit() {
        const truncateFunc = function (text, n) {
            return (text.length > n) ? text.substr(0, n - 1) + '...' : text;
        };
        this.featureSet.displayName = truncateFunc(this.featureSet.name, 10);
    }

    clicked() {
        if (this.featureSet.productCode === "L70" || this.featureSet.productCode === "L70MK2") {
            this.router.navigateByUrl("data-studio/detail/motion/" + this.featureSet.groupId);
            return;
        }
        this.router.navigateByUrl('data-studio/detail/energy/' + this.featureSet.groupId);
    }

}
